var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { shallowRef } from "vue";
import { SystemsClient, SystemStatesModel, ComponentStatusEnum, SortDirection, SortDescription } from "@/app/api/battery-portal-api";
import { TextHelper } from "@/app/utils/text-helper";
import { ArrayHelper } from "@/app/utils/array-helper";
import Sorter from "@/common/utils/sorter";
import RouteNames from "@/app/router/routes";
import QueryStringHelper from "@/app/utils/querystring-helper";
import { CacheHelper } from "@/app/utils/cache-helper";
import L from 'leaflet';
import 'leaflet.markercluster';
import DashboardReportFilterVue from "../reports/dashboard-report-filter.vue";
import { DashboardFilterModel } from "@/app/models/dashboard-filter.model";
import SystemDashboardVue from "@/app/vues/company/system-dashboard.vue";
import StringDashboardVue from "@/app/vues/company/string-dashboard.vue";
import store from "@/app/store/store";
const systemsClient = new SystemsClient(window.apiUrl);
const queryStringHelper = new QueryStringHelper();
let MapVue = class MapVue extends Vue {
    constructor() {
        //mapRef = shallowRef<any>(null);
        super(...arguments);
        this.working = false;
        this.activeTab = 0;
        this.firstTimeTabBlocks = false;
        this.statusFilterKey = 1;
        this.companyFilter = null;
        this.siteFilter = null;
        this.showReportModal = false;
        this.sorter = new Sorter(new SortDescription({
            fieldName: "SystemName",
            direction: SortDirection.Ascending
        }));
        this.url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        this.clusterOptions = {
            animate: false, // spiderfication does not work otherwise when programmatically panning to a system marker.
            iconCreateFunction: (cluster) => {
                return this.getMarkerClusterIcon(cluster);
            }
        };
        this.data = new SystemStatesModel({
            totalNumberOfSystems: 0,
            totalNumberOfGeoMappedSystems: 0,
            totalNumberOfCriticalSystems: 0,
            totalNumberOfWarningSystems: 0,
            totalNumberOfHealthySystems: 0,
            totalNumberOfUnknownSystems: 0,
            systems: new Array()
        });
        this.companies = [];
        /**
         * todo: retrieve options from the server?
         **/
        this.systemStates = [
            { selected: true, value: "critical", text: "Critical" },
            { selected: true, value: "warning", text: "Warning" },
            { selected: true, value: "healthy", text: "Ok" },
            { selected: true, value: "unknown", text: "Offline" }
        ];
    }
    created() {
        this.map = shallowRef(null);
        this.systemsLayer = shallowRef(null);
        this.restoreCachedFilter();
    }
    ;
    dataLoaded(response) {
        this.data = response;
        let systems = (this.data.systems || []).filter(system => system.siteId);
        let companies = [];
        for (let i = 0; i < systems.length; i++) {
            let company = systems[i];
            let idx = ArrayHelper.findFirstIndex(companies, (match) => {
                return match.value == company.companyId;
            });
            if (idx >= 0)
                continue;
            companies.push({ value: company.companyId || 0, text: company.companyName });
        }
        this.companies = companies.sort((a, b) => {
            if (a.text < b.text)
                return -1;
            if (a.text > b.text)
                return 1;
            return 0;
        });
        this.companies = [{ value: null, text: `All companies` }].concat(this.companies);
    }
    mounted() {
        //this.initMap();
        let hash = (this.$route.hash || "").substring(1);
        if (hash) {
            this.systemStates.forEach(item => item.selected = item.value == hash);
        }
        let hasQueryStringFilters = queryStringHelper.hasQueryString();
        if (!hasQueryStringFilters)
            return;
        if (queryStringHelper.hasParameter("statusId"))
            queryStringHelper.setFromQueryString("statusId", null, (value) => {
                var _a;
                this.systemStates.forEach(item => item.selected = item.value == hash);
                return (_a = this.systemStates.find(item => item.selected)) === null || _a === void 0 ? void 0 : _a.value;
            });
        if (queryStringHelper.hasParameter("siteId"))
            queryStringHelper.setFromQueryString("siteId", null, (value) => {
                this.siteFilter = value ? parseInt(value) : null;
                return this.siteFilter;
            });
    }
    ;
    getCssClass(system) {
        var _a;
        if (!system.statusId)
            return `unknown`;
        return ((_a = system.statusName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
    }
    ;
    getMarkerCssClass(system) {
        return `map-marker ${this.getCssClass(system)}`.trim();
    }
    ;
    getMarkerClusterIcon(cluster) {
        var nodes = cluster.getChildCount();
        let cssClass = `marker-cluster marker-cluster-small`;
        let markers = cluster.getAllChildMarkers();
        if (markers.length) {
            let classNames = markers.map((marker) => {
                if (marker)
                    return marker.options.className || "";
                return "";
            });
            if (classNames.find((className) => className.includes("critical")))
                cssClass += ` critical`;
            else if (classNames.find((className) => className.includes("warning")))
                cssClass += ` warning`;
            else if (classNames.find((className) => className.includes("healthy")))
                cssClass += ` healthy`;
        }
        let options = {
            html: `<div><span>${nodes}</span></div>`,
            className: `${cssClass} testy test test`,
            iconSize: [40, 40]
        };
        return L.divIcon(options);
    }
    ;
    // map
    initMap() {
        const mapContainer = this.$refs.dashboardMap;
        if (!mapContainer)
            return;
        if (this.map.value) {
            this.map.value.remove();
            this.map.value = null;
        }
        // Restore map position from cache if available
        const cachedMapPosition = CacheHelper.getItem(RouteNames.Home, "MapPosition");
        let initialCenter = [0, 0];
        let initialZoom = 2;
        if (cachedMapPosition && Array.isArray(cachedMapPosition.center) && typeof cachedMapPosition.zoom === 'number') {
            initialCenter = cachedMapPosition.center;
            initialZoom = cachedMapPosition.zoom;
        }
        this.map.value = L.map(mapContainer, {
            zoomAnimation: false,
            zoomSnap: 0.1,
            attributionControl: false,
            maxBounds: [[-90, -270], [90, 270]],
            maxZoom: 18,
            minZoom: 2,
        }).setView(initialCenter, initialZoom);
        L.tileLayer(this.url, {
            noWrap: false
        }).addTo(this.map.value);
        // Store map position on move/zoom
        this.map.value.on('moveend zoomend', () => {
            const center = this.map.value.getCenter();
            const zoom = this.map.value.getZoom();
            CacheHelper.storeItem(RouteNames.Home, "MapPosition", {
                center: [center.lat, center.lng],
                zoom: zoom
            });
        });
    }
    onClusterClicked(e) {
    }
    ;
    onMarkerClicked(e) {
    }
    ;
    goToSnapshot(systemId) {
        // Create a unique key and send as parameter to reload the last snapshot case the page is cached.
        var uniqueKey = Math.floor(new Date().getTime() / 1000).toString();
        this.$router.push({ name: RouteNames.SnapshotForSystem, params: { systemId: systemId.toString(), uniqueKey: uniqueKey } });
    }
    ;
    addSystemsToTheMap() {
        let addToMap = !this.systemsLayer.value;
        if (this.systemsLayer.value) {
            this.systemsLayer.value.clearLayers();
        }
        else {
            this.systemsLayer.value = L.markerClusterGroup(this.clusterOptions);
        }
        this.geoMappedSystems.forEach(system => {
            var _a;
            let popupContent = `<div class="clearfix">
						<h2>
							${TextHelper.stripHtml(system.systemName)}
						</h2>
						<div class="clearfix">
							${TextHelper.stripHtml(system.siteName)}
						</div>`;
            if (system.streetAddress3)
                popupContent +=
                    `<div class="clearfix">
							${TextHelper.stripHtml(system.streetAddress3)} ${(_a = TextHelper.stripHtml(system.streetAddress4)) !== null && _a !== void 0 ? _a : ''}
						</div>`;
            popupContent +=
                `</div>
					<div class="clearfix top10">
						<button class="btn btn-primary pw100 map-view-snapshot-btn">
							View snapshot
						</button>
					</div>`;
            let self = this;
            this.systemsLayer.value.addLayer(L.circleMarker([system.latitude, system.longitude], {
                radius: 8,
                stroke: false,
                className: this.getMarkerCssClass(system)
            }).bindPopup(popupContent)
                .on("popupopen", () => {
                $('.map-view-snapshot-btn').on('click', function (e) {
                    self.goToSnapshot(system.systemId);
                });
            })
                .bindTooltip(system.systemName));
        });
        if (addToMap) {
            this.map.value.addLayer(this.systemsLayer.value);
        }
    }
    ensureMapIsRendered(newTabIndex) {
        setTimeout(() => {
            if (newTabIndex !== 2)
                return;
            const mapContainer = this.$refs.dashboardMap;
            if (!mapContainer || mapContainer.offsetParent === null)
                return; // Not visible
            if (!this.map.value) {
                this.initMap();
            }
            this.addSystemsToTheMap();
            setTimeout(() => { this.map.value.invalidateSize(); }, 100);
        }, 100);
    }
    ;
    resetFilters() {
        this.systemStates.forEach(item => item.selected = true);
        this.companyFilter = null;
        this.siteFilter = null;
    }
    ;
    setStatusFilter(filter) {
        this.systemStates.forEach(item => item.selected = filter == '' || item.value == filter);
    }
    ;
    updateQueryString() {
        if (this.activeTab != 0 && this.map.value)
            this.addSystemsToTheMap();
        this.storeFilterToCache();
    }
    ;
    onCompanyFilterChange() {
        this.siteFilter = null;
    }
    onTabChanged() {
        this.storeFilterToCache();
        this.firstTimeTabBlocks = this.firstTimeTabBlocks || this.activeTab == 1;
    }
    // computed
    /**
    * Systems matching selected status filter
    **/
    get visibleSystems() {
        let systems = this.data.systems || [];
        if (!systems.length)
            return [];
        let selectedStatus = this.systemStates.filter(item => item.selected).map(item => item.value.toLowerCase());
        let unknownSelected = selectedStatus.includes("unknown");
        return systems.filter(system => {
            var _a;
            var filtered = selectedStatus.includes((_a = system.statusName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || (unknownSelected && !system.statusName);
            if (filtered && this.companyFilter) {
                filtered = system.companyId == this.companyFilter;
            }
            if (filtered && this.siteFilter) {
                filtered = system.siteId == this.siteFilter;
            }
            return filtered;
        });
    }
    ;
    get hasSystems() {
        return this.data && this.data.systems && this.data.systems.length ? true : false;
    }
    ;
    hasAlarms(system) {
        return system.numberOfCriticalAlarmsAck + system.numberOfWarningAlarmsAck + system.numberOfCriticalAlarmsNack + system.numberOfWarningAlarmsNack > 0;
    }
    get sites() {
        var _a;
        let sites = [];
        var systems = ((_a = this.data.systems) === null || _a === void 0 ? void 0 : _a.filter(item => !this.companyFilter || item.companyId == this.companyFilter)) || [];
        for (let i = 0; i < systems.length; i++) {
            let system = systems[i];
            let idx = ArrayHelper.findFirstIndex(sites, (match) => {
                return match.value == system.siteId;
            });
            if (idx >= 0)
                continue;
            sites.push({ value: system.siteId || 0, text: system.siteName });
        }
        sites = sites.sort((a, b) => {
            if (a.text < b.text)
                return -1;
            if (a.text > b.text)
                return 1;
            return 0;
        });
        sites = [{ value: null, text: `All sites` }].concat(sites);
        return sites;
    }
    /**
     * Systems that have a latitutde and longitude.
     **/
    get geoMappedSystems() {
        let systems = this.visibleSystems;
        var result = systems.filter(system => {
            return system.latitude != 0 && system.longitude != 0 && system.latitude >= -90 && system.latitude <= 90 && system.longitude >= -180 && system.longitude <= 180;
        });
        return result;
    }
    ;
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.companyFilter;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.companyFilter = item.value;
    }
    ;
    get selectedSite() {
        return this.sites.filter(item => {
            return item.value == this.siteFilter;
        })[0] || null;
    }
    ;
    set selectedSite(item) {
        if (!item)
            return;
        this.siteFilter = item.value;
    }
    ;
    //Report
    showSummaryStatusReportModal() {
        if (this.working)
            return;
        this.showReportModal = true;
    }
    get numberOfSeletedStatus() {
        return this.systemStates.filter(item => item.selected).length;
    }
    ;
    get statusOptionText() {
        var _a;
        if (this.numberOfSeletedStatus == this.systemStates.length)
            return `Any status`;
        if (this.numberOfSeletedStatus != 1)
            return this.systemStates.filter(item => item.selected).map(item => item.text).join(", ");
        return (_a = this.systemStates.filter(item => item.selected)[0]) === null || _a === void 0 ? void 0 : _a.text;
    }
    ;
    selectStatus(item) {
        this.ensureOneStatusSelected(!item.selected, item);
    }
    ;
    ensureOneStatusSelected(checked, item) {
        if (this.numberOfSeletedStatus <= 1) {
            item.selected = true;
            this.statusFilterKey++;
            return;
        }
        item.selected = checked;
    }
    ;
    getComponentKey(item) {
        return 'status-' + item.value + this.statusFilterKey;
    }
    get getFilteredSystemsUnknown() {
        return this.visibleSystems.filter(x => x.statusId != ComponentStatusEnum.Healthy && x.statusId != ComponentStatusEnum.Critical && x.statusId != ComponentStatusEnum.Warning).length;
    }
    storeFilterToCache() {
        let cachedFilterModel = new DashboardFilterModel();
        cachedFilterModel.statusFilter = this.systemStates;
        cachedFilterModel.companyFilter = this.companyFilter;
        cachedFilterModel.siteFilter = this.siteFilter;
        cachedFilterModel.activeTab = this.activeTab;
        CacheHelper.storeItem(RouteNames.Home, "DashboardFilterModel", cachedFilterModel);
    }
    ;
    restoreCachedFilter() {
        var _a;
        let cachedFilterModel = CacheHelper.getItem(RouteNames.Home, "DashboardFilterModel");
        if (cachedFilterModel) {
            let activeTab = (_a = cachedFilterModel.activeTab) !== null && _a !== void 0 ? _a : 0;
            if (activeTab > 1)
                activeTab = 0;
            this.activeTab = activeTab;
            this.systemStates = cachedFilterModel.statusFilter || this.systemStates;
            this.companyFilter = cachedFilterModel.companyFilter || this.companyFilter;
            setTimeout(() => {
                this.siteFilter = cachedFilterModel.siteFilter || this.siteFilter;
            }, 100);
        }
    }
    get isCloud() {
        return store.getters["licenseModule/isCloud"];
    }
};
__decorate([
    Watch("systemStates", { deep: true }),
    Watch("companyFilter"),
    Watch("siteFilter"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MapVue.prototype, "updateQueryString", null);
__decorate([
    Watch("companyFilter"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MapVue.prototype, "onCompanyFilterChange", null);
__decorate([
    Watch("activeTab"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MapVue.prototype, "onTabChanged", null);
MapVue = __decorate([
    Component({
        name: "MapVue",
        components: {
            SystemDashboardVue,
            StringDashboardVue,
            DashboardReportFilterVue
        }
    })
], MapVue);
export default MapVue;
